// extracted by mini-css-extract-plugin
export var container = "_iw-1";
export var cornerButtonContainer = "_iw-6";
export var disabled = "_iw-2";
export var dragActive = "_iw-3";
export var fileContainer = "_iw-5";
export var hiddenInput = "_iw-4";
export var widthContainer = "_iw-0";